import dayjs from 'dayjs'
import { useConversationUuid } from '~/hooks'
import { AgentTaskStatus, agentTaskStatusFromJSON, agentTaskStatusToJSON } from '~/protos/agents'
import { TaskStatuses } from '~/constants/task-status'
import { toCamelCase } from '~/utils/shared'
import { cm, verifyUUID } from '~/utils/utils'
import { Block as BlockType } from '../chat/message'
import { TaskBlockHeader } from './TaskBlockHeader'

export interface TaskBlockProps {
  children?: BlockType[]
  fields: {
    task_id: number
    status: keyof typeof AgentTaskStatus
    title: string
    created_time: number
  }
}

export const getStatusText = (status: string) => {
  if (status === agentTaskStatusToJSON(AgentTaskStatus.AGENT_INTERNAL_STATUS)) {
    return 'In Progress'
  }
  const parsed = agentTaskStatusFromJSON(status)
  return TaskStatuses[parsed]?.label || toCamelCase(status)
}

export const renderStatusBadge = (status: string) => {
  return (
    <div
      className={cm(
        'task-status font-semibold text-white',
        'bg-[rgb(0,0,0,0.2)] rounded px-2 py-[5px]'
      )}
    >
      {getStatusText(status)}
    </div>
  )
}

export function TaskBlock({ fields }: TaskBlockProps) {
  const uuid = useConversationUuid()

  if (!verifyUUID(uuid)) return null
  return (
    <div className='task w-full sticky top-0 z-40 bg-[#fbfbfb]'>
      <div className='task-info max-w-2xl space-y-2 pb-4'>
        <div className='overflow-auto'>
          <TaskBlockHeader />
        </div>
        <div className='mx-[10px] text-sm text-gray-500'>
          <div className='created-time'>
            {dayjs(fields.created_time).format('YYYY-MM-DD HH:mm')}
          </div>
        </div>
      </div>
      <hr className='mx-[10px]' />
    </div>
  )
}
